import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/firstBootSurvey/caikuma_06_reverse.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-46699f8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ribbon" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "ribbon-title" }, "カイテクへようこそ")
    ]),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("div", { class: "header-detail" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("div", { class: "header-text-wrapper" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "header-main-text" }, "\n              最適なお仕事を表示するために選択をお願いします\n            "),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("p", { class: "header-sub-text" }, "\n              この設定はあとから変更できます\n            ")
      ])
    ])
  ])
], -1))
const _hoisted_2 = { class: "question" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "question-prefix" }, "Q."),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "question-title" }, "お住まいの地域は？")
], -1))
const _hoisted_4 = { class: "question-answer question-answer-margin-right question-answer-gap" }
const _hoisted_5 = {
  key: 0,
  class: "question"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "question-prefix" }, "Q."),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "question-title" }, "お探しの業務は？")
], -1))
const _hoisted_7 = { class: "question-answer" }
const _hoisted_8 = { class: "buttons" }

import AppButton from "@/components/atoms/button/AppButton.vue";
import FormSelectGroup from "@/components/molecules/form/FormSelectGroup.vue";
import WorkTypeRadioGroup from "@/components/molecules/orders/WorkTypeRadioGroup.vue";
import { ref, computed, watch, onBeforeMount } from "vue";
import { CustomFormOption } from "@/types/form/FormOption";
import { localitiesService } from "@/app/services/LocalitiesService";
import { getFcmToken } from "@/utils/firebase";
import { accountService } from "@/app/services/AccountService";
import { authStore } from "@/store/auth";
import { useLoader } from "@/utils/loader";
import { getLocationPosition } from "@/utils/googlemap";
import { captureException } from "@/plugins/sentry";
import { masterStore } from "@/store/master";
import { Prefecture } from "@/types/Master";

type InputValue = {
  prefecture: number | null;
  locality: number | null;
  workerServiceId: number | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstBootSurveyModal',
  props: {
  show: {
    type: Boolean,
    required: true,
    default: false
  }
},
  emits: ["close"],
  setup(__props, { emit }) {




const loader = useLoader();
const prefectures = ref<Prefecture[]>([]);
const localities = ref<CustomFormOption<number>[]>([]);
const inputValue = ref<InputValue>({
  prefecture: null,
  locality: null,
  workerServiceId: null
});

const prefectureOptions = computed(() => {
  return prefectures.value.map(prefecture => {
    return {
      value: prefecture.id,
      text: prefecture.prefecture
    };
  });
});

const localityOptions = computed(() =>
  localities.value.map(locality => ({
    value: locality.value,
    text: locality.text
  }))
);

const workerServiceOptions = computed(
  () => authStore.workerServiceOptionsByProduct
);

const isShownWorkerService = computed(
  // 複数の業務カテゴリがある場合のみ選択肢を表示する
  () => workerServiceOptions.value.length >= 2
);

watch(
  () => inputValue.value.prefecture,
  async (newValue, oldValue) => {
    if (newValue === null || newValue === oldValue) return;
    const res = await localitiesService.fetchLocalitiesWithSeirei(newValue);
    localities.value = res
      // 政令指定都市は選択肢に表示しない
      .filter(l => !l.isSeirei)
      .map(locality => {
        return {
          value: locality.id,
          text: locality.city
        };
      });
    inputValue.value.locality = null;
  }
);

const onClickOk = async () => {
  loader.show();

  let fcmToken = null;
  try {
    fcmToken = await getFcmToken();
  } catch (e) {
    captureException(e as Error);
  }

  let longitude = null;
  let latitude = null;
  try {
    const locality = localityOptions.value.find(
      l => l.value === inputValue.value.locality!
    );
    if (locality) {
      const location = await getLocationPosition(locality.text);
      longitude = Math.round(location.longitude * 1e6) / 1e6;
      latitude = Math.round(location.latitude * 1e6) / 1e6;
    }
  } catch (e) {
    captureException(e as Error);
  }

  // 現在のプロダクトに紐づく業務カテゴリが1つしかない場合は、業務カテゴリは表示されていないので、その1つを設定する
  const workerServiceId = isShownWorkerService.value
    ? inputValue.value.workerServiceId!
    : workerServiceOptions.value[0].value;

  try {
    const firstBootSurvey = await accountService.registerFirstBootSurveyV2(
      fcmToken,
      workerServiceId,
      inputValue.value.prefecture!,
      inputValue.value.locality!,
      longitude,
      latitude
    );
    authStore.setFirstBootSurveyV2(firstBootSurvey);
    emit("close");
  } catch (e) {
    captureException(e as Error);
  }
  loader.hide();
};

onBeforeMount(() => {
  prefectures.value = masterStore.prefectures;
});

return (_ctx: any,_cache: any) => {
  const _component_ValidationField = _resolveComponent("ValidationField")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: __props.show,
    "no-close-on-backdrop": "",
    "content-class": "first-boot-modal-content",
    "body-class": "first-boot-modal-body",
    "no-close-on-esc": "",
    "hide-header": "",
    "hide-footer": "",
    centered: ""
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, {
        tag: "div",
        class: "body",
        initialValues: inputValue.value,
        ref: "vObserver"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createVNode(_component_ValidationField, {
                  label: "都道府県",
                  rules: "required",
                  name: "prefecture",
                  modelValue: inputValue.value.prefecture,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue.value.prefecture) = $event))
                }, {
                  default: _withCtx((validationState) => [
                    _createVNode(FormSelectGroup, {
                      firstOption: "都道府県を選択",
                      class: "prefecture-select",
                      modelValue: inputValue.value.prefecture,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue.value.prefecture) = $event)),
                      options: prefectureOptions.value,
                      "validation-state": validationState
                    }, null, 8, ["modelValue", "options", "validation-state"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createTextVNode(),
              _createElementVNode("div", null, [
                _createVNode(_component_ValidationField, {
                  label: "市区町村",
                  tag: "div",
                  rules: "required",
                  name: "locality",
                  modelValue: inputValue.value.locality,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputValue.value.locality) = $event))
                }, {
                  default: _withCtx((validationState) => [
                    _createVNode(FormSelectGroup, {
                      firstOption: "市区町村を選択",
                      class: "locality-select",
                      modelValue: inputValue.value.locality,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue.value.locality) = $event)),
                      options: localityOptions.value,
                      "validation-state": validationState
                    }, null, 8, ["modelValue", "options", "validation-state"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createTextVNode(),
          (isShownWorkerService.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_ValidationField, {
                    label: "業務",
                    name: "workerServiceId",
                    rules: "required",
                    modelValue: inputValue.value.workerServiceId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputValue.value.workerServiceId) = $event))
                  }, {
                    default: _withCtx((validationState) => [
                      _createVNode(WorkTypeRadioGroup, {
                        value: inputValue.value.workerServiceId,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((inputValue.value.workerServiceId) = $event)),
                        validationState: validationState,
                        name: "workerServiceId",
                        options: workerServiceOptions.value,
                        class: "radios"
                      }, null, 8, ["value", "validationState", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(AppButton, {
              onClick: ($event: any) => (handleSubmit(onClickOk))
            }, {
              default: _withCtx(() => [
                _createTextVNode("確定する")
              ], undefined, true),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["initialValues"])
    ], undefined, true),
    _: 1
  }, 8, ["modelValue"]))
}
}

})